import './Icon_Arrow_Wide_Up.css';

function Icon_Arrow_Wide_Up() {
  return (
    
      <div className='arrow-wide-up-icon-container'>
          <svg viewBox="0 0 24 24" className="arrow-wide-up-icon-svg">
              <path d="m3 8 4-4 4 4"/><path d="M7 4v16"/><path d="M11 12h4"/><path d="M11 16h7"/><path d="M11 20h10"/></svg>
      </div>
            
  );
}

export default Icon_Arrow_Wide_Up;

//<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-up-narrow-wide-icon lucide-arrow-up-narrow-wide">
// <path d="m3 8 4-4 4 4"/><path d="M7 4v16"/><path d="M11 12h4"/><path d="M11 16h7"/><path d="M11 20h10"/></svg>